import { Loader } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DevStatusPill } from '~/components/DevStatusPill'
import { useAuth } from '~/helpers/store/auth'
import Login from '~/pages/authentication/Login'

function App() {
  const { isLoading: authLoading, payload } = useAuth()
  const { t } = useTranslation()

  return (
    <div className="relative min-h-dvh w-full">
      {authLoading
        ? (
            <div className="flex min-h-dvh flex-col items-center justify-center gap-4">
              <Loader className="size-8 animate-spin" />
              <p>
                {t('common.loading')}
                ...
              </p>
            </div>
          )
        : !payload
            ? <Login />
            : null}

      <DevStatusPill />
    </div>
  )
}

export default App
